<script setup>
import { ref, toRef } from 'vue';
import { useAlert } from 'dashboard/composables';
import { useFunctionGetter, useStore } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import WhatsAppTemplateGallery from 'dashboard/components-next/whatsapp/WhatsAppTemplateGallery.vue';

const props = defineProps({
  inboxId: { type: Number, default: undefined },
});

const emit = defineEmits(['onSelect']);
const { t } = useI18n();
const store = useStore();
const isRefreshing = ref(false);

const whatsAppTemplateMessages = useFunctionGetter(
  'inboxes/getFilteredWhatsAppTemplates',
  toRef(props, 'inboxId')
);

const refreshTemplates = async () => {
  isRefreshing.value = true;
  try {
    await store.dispatch('inboxes/syncTemplates', props.inboxId);
    useAlert(t('WHATSAPP_TEMPLATES.PICKER.REFRESH_SUCCESS'));
  } catch (error) {
    useAlert(t('WHATSAPP_TEMPLATES.PICKER.REFRESH_ERROR'));
  } finally {
    isRefreshing.value = false;
  }
};
</script>

<template>
  <WhatsAppTemplateGallery
    :templates="whatsAppTemplateMessages"
    :is-refreshing="isRefreshing"
    show-refresh
    @select="template => emit('onSelect', template)"
    @refresh="refreshTemplates"
  />
</template>
